export enum DocumentSlice {
  Document = 'document',
  Letter = 'letter',
  Tax = 'tax',
}

export type FileDescriptor = {
  filename: string;
  fileExtension: string;
};

export type SubmitDocumentsResponse = {
  fileName: string;
};

export type UploadDocumentsResponse = {
  fileNames: string[];
};

export type FetchDocumentsResponse = {
  fetchedFiles: (FileDescriptor & { file: Record<string, number> })[];
};
